import { useEffect, useState } from "react";
import { Tag, X } from "lucide-react";
import api from "@/lib/api";

const DISMISS_KEY = "nc_promo_dismissed";

export default function AnnouncementBar() {
  const [promo, setPromo] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    api.get("/promo/active").then((r) => {
      if (r.data?.active) {
        setPromo(r.data);
        try { setDismissed(localStorage.getItem(DISMISS_KEY) === r.data.code); } catch {}
      }
    }).catch(() => {});
  }, []);

  const close = () => {
    setDismissed(true);
    try { localStorage.setItem(DISMISS_KEY, promo?.code || "1"); } catch {}
  };

  if (!promo || dismissed) return null;

  return (
    <div data-testid="promo-banner"
      className="relative bg-primary text-primary-foreground overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-2 flex items-center justify-center gap-3 text-center">
        <Tag className="w-3.5 h-3.5 shrink-0" />
        <p className="font-mono-label text-[10px] sm:text-[11px] tracking-wide leading-tight">
          New customer? Use code{" "}
          <span className="font-bold underline underline-offset-2" data-testid="promo-banner-code">{promo.code}</span>{" "}
          for {Math.round(promo.percent)}% off your first order
        </p>
      </div>
      <button onClick={close} data-testid="promo-banner-close" aria-label="Dismiss announcement"
        className="absolute right-3 top-1/2 -translate-y-1/2 opacity-70 hover:opacity-100 transition-opacity">
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
